import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names with conflict-aware deduplication.
 *
 * Lets components accept className props and override defaults cleanly:
 *   <Button className="bg-red-500">  // overrides the default bg
 *
 * Without tailwind-merge, both classes would render and Tailwind's
 * cascade ordering would decide which won (often unpredictable).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
